import {
	get, post, put, search
} from './rest';

const rootUrl = `${process.env.API_URL}/search`;

export default {
	// eslint-disable-next-line no-underscore-dangle
	get: id => get(`${rootUrl}/${id}`),
	isRunning: id => get(`${rootUrl}/${id}/running`),
	getByCaseId: caseId => search(`${rootUrl}/?caseId=${caseId}`),
	create: ({caseId, criteria}) => post(rootUrl, {caseId, criteria}),
	start: id => put(`${rootUrl}/${id}/start`),
	cancel: id => put(`${rootUrl}/${id}/cancel`)
};
